import UAParser from 'ua-parser-js'

const userAgent = UAParser()

const currentOS = userAgent.os
const currentOSString = `${currentOS.name} ${currentOS.version}`

const currentBrowser = userAgent.browser
const currentBrowserString = `${currentBrowser.name} ${currentBrowser.version}`

export default {
  os: currentOSString,
  browser: currentBrowserString,
}
